import colors from 'styles/theme/colors';

type AISummaryIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

export default function AISummaryIcon({ width = 26, height = 26, color = colors.purple100 }: AISummaryIconProps) {
  return (
    <svg width={width} height={height} viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.9525 1C19.7203 1.08277 20.481 1.17177 21.2336 1.25901C23.0759 1.47254 24.545 2.94111 24.7518 4.78423C24.8359 5.53355 24.921 6.2907 24.9999 7.05501'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.9524 25.0003C19.7202 24.9175 20.4809 24.8284 21.2335 24.7413C23.0758 24.5277 24.545 23.0592 24.7518 21.2161C24.8359 20.4668 24.9209 19.7095 24.9998 18.9453'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.04743 1C6.2796 1.08277 5.51901 1.17177 4.76629 1.25901C2.92407 1.47254 1.45481 2.94111 1.24804 4.78423C1.16397 5.53355 1.07886 6.2907 1 7.05501'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.04743 25.0003C6.2796 24.9175 5.51901 24.8284 4.76629 24.7413C2.92407 24.5277 1.45481 23.0592 1.24804 21.2161C1.16397 20.4668 1.07886 19.7095 1 18.9453'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5896 10.6087C12.0914 9.1067 12.3739 6.28125 13 6.28125C13.6262 6.28125 13.9087 9.1067 15.4105 10.6087C16.9124 12.1106 19.7189 12.2697 19.7189 13.0007C19.7189 13.7318 16.9124 13.8908 15.4105 15.3928C13.9087 16.8948 13.6262 19.7202 13 19.7202C12.3739 19.7202 12.0914 16.8948 10.5896 15.3928C9.08769 13.8908 6.28113 13.7318 6.28113 13.0007C6.28113 12.2697 9.08769 12.1106 10.5896 10.6087Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
